"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var react_1 = __importDefault(require("react"));
var _1 = require(".");
var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = _this.handleChange.bind(_this);
        return _this;
    }
    Checkbox.prototype.render = function () {
        var margin = this.props.reverse ? "ml-2" : "mr-2";
        var glyphStyle = this.props.dark ? "text-grey-lighter" : "text-grey-darker";
        var checkbox = (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("input", { onChange: this.handleChange, className: "CheckboxHidden", checked: this.props.checked, value: this.props.value, type: "checkbox" }),
            react_1.default.createElement("div", { className: "CheckboxGlyph border border-grey align-middle ".concat(glyphStyle, " ").concat(margin) })));
        return (react_1.default.createElement("span", { className: "Checkbox" }, this.props.label ? (react_1.default.createElement(_1.Label, { inline: true, reverse: !this.props.reverse, text: this.props.label, dark: this.props.dark }, checkbox)) : (react_1.default.createElement("label", null, checkbox))));
    };
    Checkbox.prototype.handleChange = function (event) {
        if (this.props.onChange)
            this.props.onChange(event);
    };
    return Checkbox;
}(react_1.default.Component));
exports.Checkbox = Checkbox;
